import styled from 'styled-components';

export const TabMenu = styled.ul<{
  selectedIndex: number;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  margin: ${({ theme }) => theme.yoga.spacing.xxxsmall}px 0;

  a {
    color: ${({ theme }) => theme.yoga.colors.deep};
    line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
    letter-spacing: ${({ theme }) => theme.yoga.spacing.zero}px;
    text-align: center;
    width: ${({ theme }) => theme.yoga.sizes.tabItemLink}px;
    margin: 0px 16px;
    font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  }

  li:nth-child(${({ selectedIndex }) => selectedIndex}) {
    border-bottom-color: ${({ theme }) => theme.yoga.colors.primary};
    a {
      color: ${({ theme }) => theme.yoga.colors.primary};
      font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
    }
  }
`;

export const TabItem = styled.li`
  display: flex;
  align-items: center;
  white-space: nowrap;

  width: ${({ theme }) => theme.yoga.sizes.tabItemWidth}px;
  border-bottom: ${({ theme }) => theme.yoga.borders.medium}px solid transparent;
  padding: 10px ${({ theme }) => theme.yoga.spacing.zero}px;
`;
